import {runInAction } from "mobx"
import {GAME_CENTER_HEADER_MODULE} from "../game-center-header-module.consts";
import {ActionHandler} from "../../../../../infrastructure/handlers/action-handler";
import type {GameCenterHeaderModuleState} from "../models/game-center-header-module.state";

export class GameCenterHeaderModuleChangeDescriptionEntityHandler extends ActionHandler {
  state: GameCenterHeaderModuleState;
  type = GAME_CENTER_HEADER_MODULE.ACTION_TYPES.changeDescriptionEntity;

  static injectables = [...ActionHandler.injectables];

  async action(params) {
    runInAction(() => {
      this.state.descriptionEntity = params?.entity || null;
    })
  }
}
